export default __webpack_public_path__ + "static/media/5-star.0e0a9a6d.png";